/** Card Spline — company /about hero (3D promo cards on the right). */
export const COMPANY_CARD_SPLINE_URL =
  "https://my.spline.design/projectpromolookatmouse-03V305jwatX2ptHNWGraixpB/";

export const COMPANY_CARD_SPLINE_EMBED_KEY = "projectpromolookatmouse-v2";

/** CSS layout scale applied to card stage (see HeroSection.css) */
export const COMPANY_CARD_LAYOUT_SCALE = 0.58;

/**
 * Card Spline render size — compensates for CSS downscale so text on cards stays sharp.
 */
export function getCompanyHeroCardRenderSize(containerW, containerH) {
  if (!containerW || !containerH) {
    return { width: 1440, height: 810 };
  }

  const dpr = Math.min(typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1, 1.5);
  const effectiveW = containerW / COMPANY_CARD_LAYOUT_SCALE;
  const effectiveH = containerH / COMPANY_CARD_LAYOUT_SCALE;

  let width = Math.round(effectiveW * dpr);
  let height = Math.round(effectiveH * dpr);

  width = Math.min(Math.max(width, 1120), 1680);
  height = Math.min(Math.max(height, 630), 945);

  const aspect = 16 / 9;
  if (width / height > aspect) {
    width = Math.round(height * aspect);
  } else {
    height = Math.round(width / aspect);
  }

  return { width, height };
}
